import React from 'react';
import { useAppContext } from '@/context';
import {
  Alert,
  Box,
  CardContent,
  Divider,
  Grid,
  Paper,
  SuccessCircleIcon,
  Typography,
  WarningCircleIcon,
} from '@availity/element';

const SecurePassword = () => {
  const { passVars } = useAppContext();
  const {
    passHas8To15,
    passHasNumber,
    passHasUpperCase,
    passHasLowerCase,
    passHasSpecial,
    passDoesntContainUserIdString,
    passDoesntContainSpaces,
  } = passVars;

  return (
    <Paper container variant="outlined" elevation={0} display="flex" flexDirection="column">
      <CardContent>
        <Grid>
          <Typography variant="h2" mb={2}>
            Password Requirements
          </Typography>
          <Divider sx={{ marginBottom: 2 }} />
        </Grid>
        <Grid container display="flex" flexDirection="row" flexWrap="wrap" mb={2}>
          <Grid>
            <Grid>
              {passHas8To15 ? (
                <SuccessCircleIcon color="success" size="sm" />
              ) : (
                <WarningCircleIcon color="warning" size="sm" />
              )}{' '}
              Have 8 to 15 characters
            </Grid>
            <Grid>
              {passHasNumber ? (
                <SuccessCircleIcon color="success" size="sm" />
              ) : (
                <WarningCircleIcon color="warning" size="sm" />
              )}{' '}
              Have at least 1 number
            </Grid>
            <Grid>
              {passHasUpperCase ? (
                <SuccessCircleIcon color="success" size="sm" />
              ) : (
                <WarningCircleIcon color="warning" size="sm" />
              )}{' '}
              Have at least 1 uppercase letter
            </Grid>
            <Grid>
              {passHasLowerCase ? (
                <SuccessCircleIcon color="success" size="sm" />
              ) : (
                <WarningCircleIcon color="warning" size="sm" />
              )}{' '}
              Have at least 1 lowercase letter
            </Grid>
            <Grid>
              {passHasSpecial ? (
                <SuccessCircleIcon color="success" size="sm" />
              ) : (
                <WarningCircleIcon color="warning" size="sm" />
              )}{' '}
              Have at least 1 special character
            </Grid>
            <Grid>
              {passDoesntContainUserIdString ? (
                <SuccessCircleIcon color="success" size="sm" />
              ) : (
                <WarningCircleIcon color="warning" size="sm" />
              )}{' '}
              Does not contain a 5-character sequence within your user ID
            </Grid>
            <Grid>
              {passDoesntContainSpaces ? (
                <SuccessCircleIcon color="success" size="sm" />
              ) : (
                <WarningCircleIcon color="warning" size="sm" />
              )}{' '}
              Does not contain spaces
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Alert severity="info">
            <Box component="span" sx={{ fontWeight: 'bold' }}>
              Tip:
            </Box>{' '}
            Common passwords such as &quot;Password123&quot; will not be accepted.
          </Alert>
        </Grid>
      </CardContent>
    </Paper>
  );
};

export default SecurePassword;
